import { render, staticRenderFns } from "./CreateBackup.vue?vue&type=template&id=5ab6c292&scoped=true&"
import script from "./CreateBackup.vue?vue&type=script&lang=js&"
export * from "./CreateBackup.vue?vue&type=script&lang=js&"
import style0 from "./CreateBackup.vue?vue&type=style&index=0&id=5ab6c292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6c292",
  null
  
)

export default component.exports